import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  styled,
} from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function ConfirmationPopup(props: any) {
  const dispatch = useDispatch();

  const handleDuplicateAndRename = () => {};

  return (
    <>
      <BootstrapDialog
        onClose={props.discardDuplicate}
        aria-labelledby="customized-dialog-title"
        open={props.isOpen}
      >
        
        <DialogContent className="modal-body">
          <div className="confirmation-dialog">
            <h1>Confirm ?</h1>
            <p>{props.message}</p>
          </div>
        </DialogContent>

        <DialogActions style={{justifyContent:"center"}}>
          <div className="modal-action confirmation-btn">
            <Button
              variant="outlined"
              className="cancel"
              onClick={props.discardDuplicate}
            >
              Discard
            </Button>
            <Button
              variant="contained"
              className="Next"
              onClick={props.handleGoBackToPrevious}
            >
              Go Back
            </Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

export default ConfirmationPopup;
